import { Content } from '@zocdoc/components/src/AppointmentPicker';
import addConstraintModals from '../../../../../Shared/Modals/addConstraintModals';
import { mockable } from '../../../../../config/mockable';

const ContentWithModals = addConstraintModals(Content);

const contentResolver = () => ContentWithModals;

const MockableContent = mockable(contentResolver);

export {
    contentResolver,
    MockableContent as default,
};
